import validator from 'validator';

const validate = (fieldName, value = null) => {
  let errors = null;
  if (value) {
    if (fieldName === 'pixel_id') {
      const pixelIdLength = 32;
      if (!validator.isNumeric(value)) {
        errors = {};
        errors[fieldName] = 'Invalid Facebook ID';
      }
      if (value.length > pixelIdLength) {
        errors = {};
        errors[fieldName] = `Facebook Pixel ID must be no longer than ${pixelIdLength} characters`;
      }
    }
    if (fieldName === 'tiktok_pixel_id') {
      const tiktokpixelIdLength = 20;
      if (value.length > tiktokpixelIdLength) {
        errors = {};
        errors[fieldName] = `TikTok Pixel ID must be no longer than ${tiktokpixelIdLength} characters`;
      }
    }
    if (fieldName === 'meta_title') {
      const metaTitleLength = 60;
      if (value.length > metaTitleLength) {
        errors = {};
        errors[fieldName] = `Meta Title must be no longer than ${metaTitleLength} characters`;
      }
    }
    if (fieldName === 'meta_description') {
      const metaDescriptionLength = 155;
      if (value.length > metaDescriptionLength) {
        errors = {};
        errors[fieldName] = `Meta Description must be no longer than ${metaDescriptionLength} characters`;
      }
    }
  }
  return errors;
};

export default validate;
